<template>
  <div>
    <p class="text-danger text-title">汇款说明：</p>
    <div class="text-info">
      <p>
        1、请您<span
          class="text-danger"
        >按照上方“保证金虚拟账号”及开户信息进行缴款。</span>
      </p>
      <p>
        2、缴纳保证金后，您可点击上方按钮确认保证金是否到账（转账可能延迟）。
      </p>
      <p>
        3、在平台上的保证金缴纳状态将显示为“已缴纳”则说明保证金到账，否则为未缴纳。
      </p>
      <p>
        4、请<span class="text-danger">一次性缴纳足额</span>保证金。当保证金缴纳不足额或多缴的情况，需待项目结束后发起退款。
      </p>
      <p>5、如未按上述要求操作导致项目参与失败，由贵单位自行承担责任。</p>
    </div>
    <p class="text-danger text-title">投标人保证金事项说明：</p>
    <div class="text-info">
      <p>
        1、为保障项目的顺利进行设置保证金环节，保证金账号为贵公司本项目专用账号；
      </p>
      <p>
        2、项目保证金金额为系统自动设定，项目结束后由采购人发起退款，平台受理后在5日内处理退款事宜；
      </p>
      <p>
        3、受招标人委托，精彩纵横电子交易平台对该项目保证金进行托管，托管期间，平台将确保资金安全；
      </p>
      <p>
        4、由采购人发起的保证金扣款事项，解释权归采购人所有，精彩纵横电子交易平台不承担任何责任；
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DepositRules'
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variable.scss';

p {
  line-height: 1.5;
  font-size: pixel-to-rem($n: 16);
}

.text-title {
  font-size: pixel-to-rem($n: 18);
}
</style>
